import { render, staticRenderFns } from "./PageStock.vue?vue&type=template&id=3952a3ef&scoped=true&"
import script from "./PageStock.vue?vue&type=script&lang=js&"
export * from "./PageStock.vue?vue&type=script&lang=js&"
import style0 from "./PageStock.vue?vue&type=style&index=0&id=3952a3ef&scoped=true&lang=css&"
import style1 from "./PageStock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952a3ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3952a3ef')) {
      api.createRecord('3952a3ef', component.options)
    } else {
      api.reload('3952a3ef', component.options)
    }
    module.hot.accept("./PageStock.vue?vue&type=template&id=3952a3ef&scoped=true&", function () {
      api.rerender('3952a3ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Stocks/PageStock.vue"
export default component.exports